import React from 'react';
import { reportClientError } from '../observability/reportClientError';
import { Button, MessageBlock } from './ui';

class RequestFlowErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const operation = this.props.operation || 'request_flow.render';
    console.error(`[${operation}] Uncaught render error`, error, info);
    reportClientError(error, { operation });
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <MessageBlock
          tone="error"
          title="No se pudo mostrar este paso"
          actions={
            <Button type="button" variant="primary" onClick={this.handleRetry}>
              Reintentar
            </Button>
          }
        >
          Ocurrió un error inesperado. Podés reintentar este paso sin recargar toda la solicitud.
        </MessageBlock>
      );
    }

    return this.props.children;
  }
}

export default RequestFlowErrorBoundary;
